import { init, identify, Identify } from '@amplitude/analytics-browser';
import { trackTime } from '@helpers/eventTracker';
import storage from '@helpers/localStorage';

enum visibilityStates {
  visible = 'visible',
  hidden = 'hidden',
}

const API_KEY = '94f23b36fa20164a205a868a9c085795';
const milliseconds = 60000;
const minutes = 60;
const FWT = 'firstWorkTime';
const LWT = 'lastWorkTime';
const WT = 'workTime';

let hasVisibilityListener = false;

async function timeTracker() {
  if (storage.read('user') && process.env.NODE_ENV === 'production') {
    await initUser(JSON.parse(storage.read('user') as string)?.id);
  }
  if (!hasVisibilityListener) {
    addVisibilityListeners();
  }
  const currentTime = new Date();
  const firstWorkTime = storage.read(FWT);
  const lastWorkTime = storage.read(LWT);
  const workTime = Number(storage.read(WT));
  if (workTime
    && firstWorkTime
    && currentTime.getDate() !== new Date(firstWorkTime).getDate()) {
    const hoursWorkTime = (workTime / milliseconds) / minutes;
    trackTime(hoursWorkTime);
    resetTrackers();
    storage.remove(WT);
    return;
  }
  if (!firstWorkTime && document.visibilityState === visibilityStates.visible) {
    storage.write(FWT, String(currentTime));
    storage.write(LWT, String(currentTime));
  }
  if (firstWorkTime && lastWorkTime && document.visibilityState === visibilityStates.hidden) {
    storage.write(WT, String(workTime + currentTime.getTime() - new Date(lastWorkTime).getTime()));
    storage.write(LWT, String(currentTime));
  }
};

export const addVisibilityListeners = () => {
  hasVisibilityListener = true;
  document.addEventListener('visibilitychange', () => {
    timeTracker();
  });
};

export const initUser = async (userId: string) => {
  await init(API_KEY, userId, {
    minIdLength: 1,
  });
  const identifyObj = new Identify();
  identifyObj.set('userId', userId);
  await identify(identifyObj);
};

export const resetTrackers = () => {
  storage.remove(FWT);
  document.removeEventListener('visibilitychange', () => { });
};

export default timeTracker;